import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Translate
import { TranslocoModule } from '@ngneat/transloco';

import { OverlayModule } from '@angular/cdk/overlay';

// Popsy
import { ErrorOverlayComponent } from './portal/error-overlay.component';
import { ErrorOverlayService } from './services/error-overlay.service';
import { ERROR_OVERLAY_DATA } from './models/error-overlay-config.interface';
import { Subscription } from 'rxjs';
import { ErrorOverlayDynamicService } from './services/error-overlay-dynamic.service';
import { RemoveIconComponent } from '@app/shared/components/icons/generated/remove/remove.component';

const COMPONENTS = [ErrorOverlayComponent];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslocoModule,
    ReactiveFormsModule,
    RemoveIconComponent,
    OverlayModule,
    ...COMPONENTS,
  ],
  providers: [ErrorOverlayService, { provide: ERROR_OVERLAY_DATA, useValue: {} }],
  exports: COMPONENTS,
})
export class ErrorOverlayModule {
  private readonly errorOverlaySubscription: Subscription;

  constructor(
    private readonly errorOverlayService: ErrorOverlayService,
    private readonly errorOverlayDynamicService: ErrorOverlayDynamicService
  ) {
    this.errorOverlaySubscription = new Subscription();
    this.errorOverlaySubscription.add(
      this.errorOverlayDynamicService.observe.subscribe({
        next: (data: any | null) => {
          if (data) {
            const overlayRef = this.errorOverlayService.open(data);

            this.errorOverlaySubscription.add(
              overlayRef.afterClosed().subscribe({
                next: () => {
                  this.errorOverlayDynamicService.close();
                },
                error: () => {},
              })
            );
          }
        },
      })
    );
  }
}
